import { Routes } from '@angular/router';
import { FarachatLayoutComponent } from './farachat-layout/layout.component';
import { LayoutComponent } from './layout/layout.component';
import { AuthGuard } from './core/guards/auth.guard';
import { LoginGuard } from './core/guards/login.guard';
import { PermissionsGuard } from './core/guards/permissions.guard';

export const routes: Routes = [
  {
    path: 'login',
    canActivate: [LoginGuard],
    loadComponent: () =>
      import('./features/auth/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'register',
    loadComponent: () =>
      import('./features/auth/register/register.component').then((m) => m.RegisterComponent),
  },
  {
    path: 'forget-pass',
    loadComponent: () =>
      import('./features/auth/forget-pass/forget-pass.component').then(
        (m) => m.ForgetPassComponent,
      ),
  },
  {
    path: 'change-password',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./features/auth/change-password/change-password.component').then(
        (m) => m.ChangePasswordComponent,
      ),
  },
  {
    path: 'developer',
    loadComponent: () =>
      import('./features/others/developer/developer.component').then((m) => m.DeveloperComponent),
  },
  {
    path: 'palletes',
    loadComponent: () =>
      import('./features/others/palletes/palletes.component').then((m) => m.PalletesComponent),
  },
  {
    path: 'user_guide',
    loadComponent: () =>
      import('./features/others/guide/guide.component').then((m) => m.GuideComponent),
  },
  {
    path: 'FAQ',
    loadComponent: () =>
      import('./features/others/faq/faq.component').then((m) => m.FaqPageComponent),
  },
  {
    path: '',
    canActivate: [AuthGuard],
    component: LayoutComponent,
    children: [
      {
        path: '',
        redirectTo: 'ai-agent',
        pathMatch: 'full',
      },
      {
        path: 'ai-agent',
        component: FarachatLayoutComponent,
        children: [
          {
            path: '',
            redirectTo: 'chat',
            pathMatch: 'full',
          },
          {
            path: 'chat',
            loadComponent: () =>
              import('./features/layout-pages/ai-agent-pages/chat/chat.component').then(
                (m) => m.ChatComponent,
              ),
            canActivate: [PermissionsGuard],
          },
          {
            path: 'prompts',
            loadComponent: () =>
              import('./features/layout-pages/ai-agent-pages/prompts/prompts.component').then(
                (m) => m.PromptsComponent,
              ),
            canActivate: [PermissionsGuard],
          },
          {
            path: 'plugins',
            loadComponent: () =>
              import('./features/layout-pages/ai-agent-pages/plugins/plugins.component').then(
                (m) => m.PluginsComponent,
              ),
          },
          {
            path: 'ai-models',
            loadComponent: () =>
              import('./features/layout-pages/ai-agent-pages/ai-models/ai-models.component').then(
                (m) => m.AiModelsComponent,
              ),
            canActivate: [PermissionsGuard],
          },
          {
            path: 'agents',
            loadComponent: () =>
              import('./features/layout-pages/ai-agent-pages/agents/agents.component').then(
                (m) => m.AgentsComponent,
              ),
            canActivate: [PermissionsGuard],
          },
          {
            path: 'kb',
            loadComponent: () =>
              import('./features/layout-pages/ai-agent-pages/kb/kb.component').then(
                (m) => m.KbComponent,
              ),
            canActivate: [PermissionsGuard],
          },
          {
            path: 'teams-tree',
            loadComponent: () =>
              import(
                './features/layout-pages/ai-agent-pages/teams-tree-view/teams-tree-view.component'
              ).then((m) => m.TeamsTreeView),
            canActivate: [PermissionsGuard],
          },
          {
            path: 'teams',
            loadComponent: () =>
              import('./features/layout-pages/ai-agent-pages/teams/teams.component').then(
                (m) => m.TeamsComponent,
              ),
            canActivate: [PermissionsGuard],
          },
          {
            path: 'teams/:id',
            loadComponent: () =>
              import(
                './features/layout-pages/ai-agent-pages/teams-detail/teams-detail.component'
              ).then((m) => m.TeamsDetailComponent),
            canActivate: [PermissionsGuard],
          },
        ],
      },
      {
        path: 'profile',
        loadComponent: () =>
          import('./features/layout-pages/profile/profile.component').then(
            (m) => m.ProfileComponent,
          ),
      },
      {
        path: 'settings',
        loadComponent: () =>
          import('./features/layout-pages/settings/settings.component').then(
            (m) => m.SettingsComponent,
          ),
      },
      {
        path: 'messenger',
        loadComponent: () =>
          import('./features/layout-pages/collab-container/collab-container.component').then(
            (m) => m.UsersChatComponent,
          ),
      },
      {
        path: 'jobs',
        loadComponent: () =>
          import('./features/layout-pages/jobs/jobs.component').then((m) => m.JobsComponent),
      },
      {
        path: 'calendar',
        loadComponent: () =>
          import('./features/layout-pages/calendar/calendar.component').then(
            (m) => m.CalendarComponent,
          ),
      },
      {
        path: 'planner',
        loadComponent: () =>
          import('./features/layout-pages/planner/planner.component').then(
            (m) => m.PlannerComponent,
          ),
      },
    ],
  },
  {
    path: 'not-found',
    loadComponent: () =>
      import('./features/others/not-found/not-found.component').then((m) => m.NotFoundComponent),
  },
  {
    path: '**',
    redirectTo: 'not-found',
  },
];
